import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import { THUMB_SIZE } from "./timePickerConstants";
interface SliderThumbProps {
  testId: string;
  label: string;
  valueMin: number;
  valueMax: number;
  valueNow: number;
  valueText: string;
  leftPercent: number;
  onPointerDown: (e: React.PointerEvent) => void;
}
export const SliderThumb = t0 => {
  const $ = _c(10);
  const {
    testId,
    label,
    valueMin,
    valueMax,
    valueNow,
    valueText,
    leftPercent,
    onPointerDown
  } = t0;
  const t1 = `${leftPercent}%`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box width="0" height="0" borderLeft="3px solid transparent" borderRight="3px solid transparent" borderBottom="4px solid white" mt="-1px" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label || $[2] !== onPointerDown || $[3] !== t1 || $[4] !== testId || $[5] !== valueMax || $[6] !== valueMin || $[7] !== valueNow || $[8] !== valueText) {
    t3 = <Box data-testid={testId} role="slider" aria-label={label} aria-valuemin={valueMin} aria-valuemax={valueMax} aria-valuenow={valueNow} aria-valuetext={valueText} tabIndex={0} position="absolute" bottom="-0.9375rem" left={t1} transform="translateX(-50%)" width={THUMB_SIZE} height={THUMB_SIZE} bg="grey.600" borderRadius="full" cursor="pointer" zIndex={2} display="flex" alignItems="center" justifyContent="center" onPointerDown={onPointerDown}>{t2}</Box>;
    $[1] = label;
    $[2] = onPointerDown;
    $[3] = t1;
    $[4] = testId;
    $[5] = valueMax;
    $[6] = valueMin;
    $[7] = valueNow;
    $[8] = valueText;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};